<template>
  <section class="pneu-specs">
    <div class="container">
      <div class="specs-header">
        <h2 class="specs-title">{{ t('specs.title') }}</h2>
      </div>

      <div class="specs-content" v-if="!isLoading">
        <table class="specs-table">
          <tbody>
            <tr
              v-for="(spec, index) in especificacoes"
              :key="index"
              class="spec-row"
            >
              <td class="spec-name">{{ spec.nome }}</td>
              <td class="spec-value">
                {{ spec.valor || t('specs.notAvailable') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="loading-container">
        <EspecificacoesSkeleton />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import EspecificacoesSkeleton from './EspecificacoesSkeleton.vue';
import { fetchProductDetails } from '@/services/apiService';

const { t } = useI18n();
const route = useRoute();
const slug = route.params.slug;

const especificacoes = ref([]);
const isLoading = ref(true);

const fetchProductData = async () => {
  try {
    const data = await fetchProductDetails(slug);
    especificacoes.value = data.especificacoes || [];
  } catch (error) {
    console.error('Erro ao buscar os dados do produto:', error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(fetchProductData);
</script>


<style scoped>
.pneu-specs {
  background-color: #f9f9f9;
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 20px;
  margin-top: 20px;
}

.specs-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.specs-title {
  font-family: 'Oswald', sans-serif;
  font-size: 1.75rem;
  font-weight: 500;
  color: #ff5c5c;
  margin-bottom: 10px;
}

.specs-table {
  width: 100%; 
  border-collapse: collapse; 
  margin-top: 20px;
  background-color: #ffffff; 
  border-radius: 12px; 
  overflow: hidden; 
  
}

.spec-row {
  background-color: #ffffff; 
}

.specs-table td {
  padding: 16px; 
  font-family: 'Oswald', sans-serif;
  font-size: 1.4rem; 
  color: #555;
  border-bottom: 2px solid #F9F9F9; 
  border-right: 2px solid #F9F9F9; 
  width: 50%;
  white-space: normal; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  padding: 16px; 
  line-height: 1.2; 
}
.specs-table tr {
  line-height: 0.2; 
  height: auto;
}
.specs-table td:last-child {
  border-right: none; 
}

.spec-name {
  text-align: left; 
  font-weight: 400;
}

.spec-value {
  text-align: right; 
  font-weight: 400;
  color: #555;
}

.specs-table tr:last-child td {
  border-bottom: none;
}

.specs-table tr:first-child td:first-child {
  border-top-left-radius: 12px;
}

.specs-table tr:first-child td:last-child {
  border-top-right-radius: 12px; 
}

.specs-table tr:last-child td:first-child {
  border-bottom-left-radius: 12px; 
}

.specs-table tr:last-child td:last-child {
  border-bottom-right-radius: 12px; 
}


.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}

.container {
  width: 100%; 
  max-width: none; 
  padding: 0; 
}
</style>
